export default {
  pt:{
    ano: "Ano",
    calendarios: "Calendários",
    curso: "Curso",
    data: "Data",
    designacao: "Designação",
    documentos: "Documentos",
    noticia: "Notícia",
    resultados: "Resultados",
    semdoc: "Sem documentos para apresentar",
    semnoticias: "Sem notícias para apresentar",
    semresultados: "Sem resultados para apresentar",
    semcursos: "Sem cursos para apresentar",
    semcalendarios: "Sem calendários para apresentar",
    semprovas: "Não foram encontradas provas",
    vermais: "Ver Mais",
    provas: "Provas",
    provaaval: "Prova de Avaliação",
    pesquisarDocs: "Pesquisar Documentos",
    pesquisarresultados: "Pesquisar Resultados",
    menu:{
      apresentacao: "Apresentação",
      noticias: "Notícias",
      calendarios: "Calendários",
      provas: "Inscrições nas Provas",
      cursos: "Cursos",
      paccs: "PACCS - Programa e Enunciados",
      resultados: "Resultados",
      documentacao: "Documentação",
      faq: "Perguntas Frequentes"
    },
    apesquisar: "A pesquisar",
    textoapresentacao:`<p>Uma das formas de acesso às Licenciatura e aos Cursos Técnicos Superiores Profissionais é através do 
        <strong>Concurso Especial para acesso e ingresso no ensino superior para titulares de provas especialmente adequadas, 
        destinadas a avaliar a capacidade para a frequência do ensino superior dos maiores de 23 anos</strong>, abreviadamente 
        designadas por <strong>“Provas para Maiores de 23 Anos”</strong>.</p> <p>Podem concorrer a este concurso especial os candidatos 
        aprovados nas provas para maiores de 23 anos, que não sejam titulares de habilitação de acesso ao ensino superior, que satisfaçam 
        os pré-requisitos, quando exigidos pelo curso pretendido e que não estejam abrangidos pelo estatuto do estudante internacional 
        (cf. Decreto-Lei n.º 36/2014, de 10 de março, alterado e republicado pelo Decreto-Lei n.º 62/2018, de 6 agosto).</p> 
        <p>Podem inscrever-se para a realização destas provas os cidadãos que tenham completado 23 anos até ao dia 31 de dezembro do ano que antecede a realização 
        das mesmas e que não sejam titulares de habilitação de acesso ao ensino superior.</p> <p>A avaliação da 
        capacidade para a frequência do ensino superior para maiores de 23 anos integra três componentes de
        avaliação:</p> <ul><li>A realização das provas de avaliação de conhecimentos e competências (PACC), 
        que consistem de provas escritas para avaliação dos conhecimentos e competências considerados 
        indispensáveis ao ingresso e progressão num ciclo de estudos;</li> <li>a apreciação do currículo
        escolar e profissional do candidato;</li> <li>a avaliação das motivações do candidato 
        através da realização de uma entrevista.</li></ul> <p>Os candidatos que obtiverem uma classificação final igual ou superior a dez valores 
        ficam habilitados a concorrer ao Concurso especial de acesso para maiores de 23 anos.</p> <p>Assim, resumidamente, as etapas necessárias para o 
        acesso ao ensino superior por esta via são as seguintes:</p> <ol><li>Inscrição nas provas para maiores de 23 anos (PACCs);</li> 
        <li>Obtenção de uma nota nota superior ou igual a 7,5 valores em cada uma das PACCs (exigidas para candidatura ao curso pretendido);</li> 
        <li>Obtenção de uma nota nota superior ou igual a 7,5 valores na entrevista;</li> 
        <li>Obtenção de uma classificação final superior ou igual a 9,5 valores (sendo esta classificação final o resultado de uma média ponderada das notas 
          obtidas nas PACCs, na avaliação curricular e na entrevista);</li> <li>Candidatura ao concurso especial para maiores de 23 anos;</li> 
          <li>Colocação numa das vagas para o curso pretendido disponibilizadas no referido concurso (após a seriação dos candidatos);</li> 
          <li>Matricula e inscrição no curso pretendido.</li></ol>`,
  },
  en: {
    ano: "Year",
    calendarios: "Calendários",
    curso: "Course",
    data: "Date",
    designacao: "Designação",
    documentos: "Documents",
    noticia: "News",
    resultados: "Results",
    semdoc: "Sem documentos para apresentar",
    semnoticias: "Sem notícias para apresentar",
    semresultados: "Sem resultados para apresentar",
    semcursos: "Sem cursos para apresentar",
    semcalendarios: "Sem calendários para apresentar",
    semprovas: "Não foram encontradas provas",
    vermais: "See More",
    provas: "Provas",
    provaaval: "Prova de Avaliação",
    pesquisarDocs: "Search Documents",
    pesquisarresultados: "Pesquisar Resultados",
    menu:{
      apresentacao: "Introduction",
      noticias: "News",
      calendarios: "Calendars",
      provas: "Candidaturas às Provas",
      cursos: "Courses",
      paccs: "PACCS - Programa e Enunciados",
      resultados: "Results",
      documentacao: "Documentation",
      faq: "Frequently Asked Questions"
    },
    apesquisar: "Searching",
    textoapresentacao:`<p>Uma das formas de acesso às Licenciatura e aos Cursos Técnicos Superiores Profissionais é através do 
        <strong>Concurso Especial para acesso e ingresso no ensino superior para titulares de provas especialmente adequadas, 
        destinadas a avaliar a capacidade para a frequência do ensino superior dos maiores de 23 anos</strong>, abreviadamente 
        designadas por <strong>“Provas para Maiores de 23 Anos”</strong>.</p> <p>Podem concorrer a este concurso especial os candidatos 
        aprovados nas provas para maiores de 23 anos, que não sejam titulares de habilitação de acesso ao ensino superior, que satisfaçam 
        os pré-requisitos, quando exigidos pelo curso pretendido e que não estejam abrangidos pelo estatuto do estudante internacional 
        (cf. Decreto-Lei n.º 36/2014, de 10 de março, alterado e republicado pelo Decreto-Lei n.º 62/2018, de 6 agosto).</p> 
        <p>Podem inscrever-se para a realização destas provas os cidadãos que tenham completado 23 anos até ao dia 31 de dezembro do ano que antecede a realização 
        das mesmas e que não sejam titulares de habilitação de acesso ao ensino superior.</p> <p>A avaliação da 
        capacidade para a frequência do ensino superior para maiores de 23 anos integra três componentes de
        avaliação:</p> <ul><li>A realização das provas de avaliação de conhecimentos e competências (PACC), 
        que consistem de provas escritas para avaliação dos conhecimentos e competências considerados 
        indispensáveis ao ingresso e progressão num ciclo de estudos;</li> <li>a apreciação do currículo
        escolar e profissional do candidato;</li> <li>a avaliação das motivações do candidato 
        através da realização de uma entrevista.</li></ul> <p>Os candidatos que obtiverem uma classificação final igual ou superior a dez valores 
        ficam habilitados a concorrer ao Concurso especial de acesso para maiores de 23 anos.</p> <p>Assim, resumidamente, as etapas necessárias para o 
        acesso ao ensino superior por esta via são as seguintes:</p> <ol><li>Inscrição nas provas para maiores de 23 anos (PACCs);</li> 
        <li>Obtenção de uma nota nota superior ou igual a 7,5 valores em cada uma das PACCs (exigidas para candidatura ao curso pretendido);</li> 
        <li>Obtenção de uma nota nota superior ou igual a 7,5 valores na entrevista;</li> 
        <li>Obtenção de uma classificação final superior ou igual a 9,5 valores (sendo esta classificação final o resultado de uma média ponderada das notas 
          obtidas nas PACCs, na avaliação curricular e na entrevista);</li> <li>Candidatura ao concurso especial para maiores de 23 anos;</li> 
          <li>Colocação numa das vagas para o curso pretendido disponibilizadas no referido concurso (após a seriação dos candidatos);</li> 
          <li>Matricula e inscrição no curso pretendido.</li></ol>`,
  }
}